import { connect } from 'react-redux';

import { ProviderPriceList } from '../../../models/Entities/ProviderAssociations/PriceLists/ProviderPriceList';

import * as ProviderPriceListAssociationStore from '../../../redux/middleware/ProviderPriceListAssociationMiddleware';
import { PriceListInfoPanel } from './PriceListInfoPanel';

export interface IProps {
  ProviderPriceList: ProviderPriceList;
}

interface DispatchProps {
  SetStartValidity: typeof ProviderPriceListAssociationStore.actionCreators.SetStartValidity;
  SetEndValidity: typeof ProviderPriceListAssociationStore.actionCreators.SetEndValidity;
}

type Props = IProps & DispatchProps;

const ProviderPriceListInfoComponentBase = (props: Props) => (
  <PriceListInfoPanel
    priceList={props.ProviderPriceList}
    i18nRoot="providerPriceListInfo"
    onConfirmStartValidity={(date) =>
      props.SetStartValidity(props.ProviderPriceList.id, date)
    }
    onConfirmEndValidity={(date) =>
      props.SetEndValidity(props.ProviderPriceList.id, date)
    }
  />
);

const mapDispatchToProps = {
  SetStartValidity: ProviderPriceListAssociationStore.actionCreators.SetStartValidity,
  SetEndValidity: ProviderPriceListAssociationStore.actionCreators.SetEndValidity
};

export const ProviderPriceListInfoComponent = connect(
  null,
  mapDispatchToProps
)(ProviderPriceListInfoComponentBase as any) as any;

export default ProviderPriceListInfoComponent;
